import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const saleBanner = () => {
  return (
    <motion.div
      initial={{ y:-3, opacity: 0 }}
      whileInView={{y: 0, opacity: 1 }}
      viewport={{ once: false, amount: 0.4 }}
      transition={{
        type: "spring",
        duration: 2,
      }}
    >
      {" "}
      <Component>
        <div>
          <img
            className="right"
            src="https://m.media-amazon.com/images/I/81Qx4-0fWjS._AC_UY625_.jpg"
            alt=""
          />
        </div>

        <img
          className="left"
          src="https://m.media-amazon.com/images/I/715aN3mSQBL._AC_UY879_.jpg"
          alt=""
        />

        <Overlay />

        <OverlayWritings>
          <div className="border">
            <div className="innerBorder">SALES</div>
          </div>
        </OverlayWritings>
      </Component>{" "}
    </motion.div>
  );
};

export default saleBanner;

const Component = styled.div`
  position: relative;
  width: 95%;
  margin: 40px auto;
  height: 70vh;
  background-color: #fff;
  img {
    position: absolute;
    z-index: 1;
    height: 100%;
    object-fit: contain;
    right: 20px;
  }
  .left {
    position: absolute;
    z-index: 1;
    height: 100%;
    object-fit: contain;
    left: 20px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
`;

const OverlayWritings = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 4;
  color: white;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  h4 {
    background-color: black;
  }

  .innerBorder {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: black;
    padding: 20px 10px;

    letter-spacing: 20px;
  }

  .border {
    border: 1px solid #f227a1;
    padding: 24px 14px;
  }
`;

const Backdroptext = styled.div`
  position: absolute;
  z-index: -1;
  font-weight: 1000;
  letter-spacing: 20px;
  font-family: sans-serif;
  font-size: 70px;
  p {
  }
  span {
    transform: rotate(30deg);
  }
  color: #dedede;
`;
